import { ButtonERP, Dialog, TagERP } from "@finanedi.es/storybook"
import { faDownload, faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import notification from "common/utils/notification"
import { Dispatch, SetStateAction, useState } from "react"
import { useTranslation } from "react-i18next"

interface ModalPresentarModeloProps<TFormData, KGenerarFicheroModelo> {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  nombreDocumento: string
  postDeclaracion: (data: KGenerarFicheroModelo) => Promise<Blob | ArrayBuffer>
  postDeclaracionAdapter: (data: TFormData) => KGenerarFicheroModelo
  modalTitle: string
  infoText: string
  values: TFormData
}

export const ModalPresentarModelo = <TFormData, KGenerarFicheroModelo>({
  show,
  setShow,
  nombreDocumento,
  postDeclaracion,
  postDeclaracionAdapter,
  modalTitle,
  infoText,
  values,
}: ModalPresentarModeloProps<TFormData, KGenerarFicheroModelo>) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const submitModelo = async (data: TFormData) => {
    const formData = postDeclaracionAdapter(data)
    try {
      setLoading(true)
      const blobResponse = await postDeclaracion(formData)
      const blob = new Blob([blobResponse], { type: "text/plain" })
      const link = document.createElement("a")

      link.href = URL.createObjectURL(blob)
      link.download = `${nombreDocumento}`
      link.click()

      URL.revokeObjectURL(link.href)
      notification.success({ body: `${t("successMsg.downloadDocument")}` })
      setShow(!show)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      setShow(!show)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      header={`${t(modalTitle)}`}
      headerClassName='!tw-text-lg'
      visible={show}
      onHide={() => setShow(!show)}
      maskClassName='!tw-p-6'
      className='!tw-mt-6 !tw-w-96'
      baseZIndex={30}
      draggable
    >
      <div className='tw-w-full tw-flex tw-gap-3 tw-flex-col tw-text-sm'>
        <TagERP
          color='info'
          icon={<FontAwesomeIcon icon={faInfoCircle} />}
          value={t(infoText)}
          className='!tw-rounded-md'
        />
        <div className='tw-w full tw-flex tw-flex-row tw-justify-end'>
          <ButtonERP
            customize={{ type: "primary", size: "md" }}
            label={`${t("taxSummary.declaracion.modal.download")}`}
            onClick={() => submitModelo(values)}
            icon={<FontAwesomeIcon icon={faDownload} />}
            loading={loading}
          />
        </div>
      </div>
    </Dialog>
  )
}
